import { AdapterFactory } from '../AdapterFactory';

export const billingService = AdapterFactory.getBillingAdapter();
